import Layout from "../../layout/main";
import WalletCreditBalanceReports from "../../components/walletCreditBalanceReports";
/**
 * WalletCreditBalanceReportsPage
 *
 * صفحه گزارش ها موجودی اعتباری کیف پول.
 * رندر کامپوننت WalletCreditBalanceReports داخل لایه اصلی Layout برای نمایش گزارش ها اعتباری کیف پول.
 *
 * @returns JSX.Element
 */

const WalletCreditBalanceReportsPage = () => {
  return (
    <Layout>
      <WalletCreditBalanceReports />
    </Layout>
  );
};

export default WalletCreditBalanceReportsPage;
